import { z } from "zod";
import { AbstractExtractSchema } from "./abstract/abstractExtract.entities";

export enum ExtractLaboratorySchemaEnum {
	ExtractLaboratory = "ExtractLaboratory"
};

export const ExtractLaboratorySchema = AbstractExtractSchema
	.merge(z.object({
		"@id": z.string(), // "/api/extract_laboratories/1"
		"@type": z.string(), // "ExtractLaboratory"
		id: z.number(),	// 1
		aw_laboratory_id: z.string(),	// "1"
		libelle: z.string(), // "Laboratory 1"
	}))
	.describe(ExtractLaboratorySchemaEnum.ExtractLaboratory);

export type ExtractLaboratory = z.infer<typeof ExtractLaboratorySchema>;
